import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { PageLoading } from "../shared";
import { useAuth } from "../hooks/useAuth";
import { usePermissions } from "../hooks/usePermissions";

const RequirePermission = ({ permission, children, fallbackPath = "/" }) => {
  const location = useLocation();
  const { initialized, user } = useAuth();
  const { hasPermission } = usePermissions();

  if (!initialized) {
    return <PageLoading />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasPermission(permission)) {
    return <Navigate to={fallbackPath} replace state={{ from: location }} />;
  }

  return children;
};

export default RequirePermission;
